import { handleActions } from 'redux-actions';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  orientationsList: [],
  locationsList: [],
  orientationDetails: {
    location: {}
  }
};

export default handleActions(
  {
    [actionTypes.GET_ORIENTATION_LOCATIONS_SUCCESS]: (state, action) => ({
      ...state,
      locationsList: action.data.orientation_locations
    }),
    [actionTypes.GET_ORIENTATIONS_SUCCESS]: (state, action) => ({
      ...state,
      orientationsList: action.data.orientations
    }),
    [actionTypes.GET_ORIENTATION_DETAILS_SUCCESS]: (state, action) => ({
      ...state,
      orientationDetails: action.data.orientation
    })
  }, initialState
);



// WEBPACK FOOTER //
// ./src/reducers/orientations.js